import React from 'react';
import cn from 'classnames';

type CardContentProps = {
  className?: string
  noBorders: boolean
  loading?: boolean
}

export default function CardContent({
  className,
  noBorders,
  loading,
  children,
}: React.PropsWithChildren<CardContentProps>) {
  return (
    <div className={cn('pt-3', className, {'px-5': !noBorders, 'cursor-wait': loading})}>
      <div className="relative">
        {loading &&
        <div className="w-full h-full z-50 absolute bg-gray-light bg-opacity-80 flex items-center place-content-center">
          <span className="bg-white rounded-md py-2 px-4">Loading...</span>
        </div>
        }
        {children}
      </div>
    </div>
  );
}
